import { render, staticRenderFns } from "./StudyPlanHistoryModal.vue?vue&type=template&id=005936d6&scoped=true&"
import script from "./StudyPlanHistoryModal.vue?vue&type=script&lang=js&"
export * from "./StudyPlanHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./StudyPlanHistoryModal.vue?vue&type=style&index=0&id=005936d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005936d6",
  null
  
)

export default component.exports